// extracted by mini-css-extract-plugin
export default {"Layer":"📚19-10-2EuOUU","BladeLayer":"📚19-10-2_bcQS","Translucent":"📚19-10-2sCLKU","disableScroll":"📚19-10-2G6VL6"};